import request from '@/utils/request'
import Resource from '@/apis/resource'
class CargasResource extends Resource {
  constructor() {
    super('api/cargas')
  }
  fetchAnios() {
    return request({
      url: '/' + this.uri+'/Anio',
      method: 'get'
    })
  }
  fetchAnioMax() {
    return request({
      url: '/' + this.uri+'/AnioMax',
      method: 'get'
    })
  }
  fetchMeses(id) {
    return request({
      url: '/' + this.uri+'/Meses/'+id,
      method: 'get'
    })
  }
  fetchMesMax(id) {
    return request({
      url: '/' + this.uri+'/MesMax/'+id,
      method: 'get'
    })
  }
}
export { CargasResource as default }